/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { blockManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
import core from "../../../blocks/_core";
import DataRoadSafetyChartContainer from "../../../blocks/data/road-safety-chart-container.tsx";
import DataRoadSafetySectionHeader from "../../../blocks/data/road-safety-section-header.tsx";
import FormsGravityForm from "../../../blocks/forms/gravity-form.tsx";
import GeneralAccordionGroup from "../../../blocks/general/accordion-group.tsx";
import GeneralAnchor from "../../../blocks/general/anchor.tsx";
import GeneralBuyAnIdp from "../../../blocks/general/buy-an-idp.tsx";
import GeneralCardDashboard from "../../../blocks/general/card-dashboard.tsx";
import GeneralCardFocusArea from "../../../blocks/general/card-focus-area.tsx";
import GeneralCardMulti from "../../../blocks/general/card-multi.tsx";
import GeneralCardPillars from "../../../blocks/general/card-pillars.tsx";
import GeneralCardSingle from "../../../blocks/general/card-single.tsx";
import GeneralChart from "../../../blocks/general/chart.tsx";
import GeneralChildPages from "../../../blocks/general/child-pages.tsx";
import GeneralClubList from "../../../blocks/general/club-list.tsx";
import GeneralContactPanel from "../../../blocks/general/contact-panel.tsx";
import GeneralDataInsight from "../../../blocks/general/data-insight.tsx";
import GeneralFileDownloadGroup from "../../../blocks/general/file-download-group.tsx";
import GeneralFooterCta from "../../../blocks/general/footer-cta.tsx";
import GeneralGetInvolved from "../../../blocks/general/get-involved.tsx";
import GeneralHeaderWithLinks from "../../../blocks/general/header-with-links.tsx";
import GeneralIdpCheck from "../../../blocks/general/idp-check.tsx";
import GeneralInlineCta from "../../../blocks/general/inline-cta.tsx";
import GeneralMultiDropdownWidget from "../../../blocks/general/multi-dropdown-widget.tsx";
import GeneralMultiSectionWidget from "../../../blocks/general/multi-section-widget.tsx";
import GeneralNextPage from "../../../blocks/general/next-page.tsx";
import GeneralPillList from "../../../blocks/general/pill-list.tsx";
import GeneralProjects from "../../../blocks/general/projects.tsx";
import GeneralQuickLinks from "../../../blocks/general/quick-links.tsx";
import GeneralQuoteSwiper from "../../../blocks/general/quote-swiper.tsx";
import GeneralTeamMembers from "../../../blocks/general/team-members.tsx";
import GeneralTimedCards from "../../../blocks/general/timed-cards.tsx";
import GeneralTitleWithButton from "../../../blocks/general/title-with-button.tsx";
import HomeHeroDocumentHighlight from "../../../blocks/home/hero-document-highlight.tsx";
import MailchimpUpdatePreferences from "../../../blocks/mailchimp/update-preferences.tsx";
import NewsCategoryFilter from "../../../blocks/news/category-filter.tsx";
import NewsCuratedDocuments from "../../../blocks/news/curated-documents.tsx";
import NewsCuratedNews from "../../../blocks/news/curated-news.tsx";
import NewsHeroArticle from "../../../blocks/news/hero-article.tsx";
import PublicationsPublicationsGroup from "../../../blocks/publications/publications-group.tsx";
import PublicationsPublicationsList from "../../../blocks/publications/publications-list.tsx";

const manifest = {
  "acf/data-data-header": dynamic(() => import("../../../blocks/data/data-header.tsx"), "blocks/data/data-header.tsx"),
  "acf/data-evindex-fuel-type-over-time": dynamic(
    () => import("../../../blocks/data/evindex-fuel-type-over-time.tsx"),
    "blocks/data/evindex-fuel-type-over-time.tsx",
  ),
  "acf/data-evindex-geographical-distribution": dynamic(
    () => import("../../../blocks/data/evindex-geographical-distribution.tsx"),
    "blocks/data/evindex-geographical-distribution.tsx",
  ),
  "acf/data-evindex-header": dynamic(
    () => import("../../../blocks/data/evindex-header.tsx"),
    "blocks/data/evindex-header.tsx",
  ),
  "acf/data-evindex-international-comparison": dynamic(
    () => import("../../../blocks/data/evindex-international-comparison.tsx"),
    "blocks/data/evindex-international-comparison.tsx",
  ),
  "acf/data-evindex-intro-page": dynamic(
    () => import("../../../blocks/data/evindex-intro-page.tsx"),
    "blocks/data/evindex-intro-page.tsx",
  ),
  "acf/data-evindex-new-vehicle-sales": dynamic(
    () => import("../../../blocks/data/evindex-new-vehicle-sales.tsx"),
    "blocks/data/evindex-new-vehicle-sales.tsx",
  ),
  "acf/data-evindex-sales-by-fuel-type": dynamic(
    () => import("../../../blocks/data/evindex-sales-by-fuel-type.tsx"),
    "blocks/data/evindex-sales-by-fuel-type.tsx",
  ),
  "acf/data-evindex-sales-by-manufacturer": dynamic(
    () => import("../../../blocks/data/evindex-sales-by-manufacturer.tsx"),
    "blocks/data/evindex-sales-by-manufacturer.tsx",
  ),
  "acf/data-evindex-sales-by-vehicle-and-fuel": dynamic(
    () => import("../../../blocks/data/evindex-sales-by-vehicle-and-fuel.tsx"),
    "blocks/data/evindex-sales-by-vehicle-and-fuel.tsx",
  ),
  "acf/data-evindex-sales-jurisdiction": dynamic(
    () => import("../../../blocks/data/evindex-sales-jurisdiction.tsx"),
    "blocks/data/evindex-sales-jurisdiction.tsx",
  ),
  "acf/data-evindex-vehicle-specification-information": dynamic(
    () => import("../../../blocks/data/evindex-vehicle-specification-information.tsx"),
    "blocks/data/evindex-vehicle-specification-information.tsx",
  ),
  "acf/data-road-safety-block": dynamic(
    () => import("../../../blocks/data/road-safety-block.tsx"),
    "blocks/data/road-safety-block.tsx",
  ),
  "acf/data-road-safety-chart-container": DataRoadSafetyChartContainer,
  "acf/data-road-safety-section-header": DataRoadSafetySectionHeader,
  "acf/data-road-safety-state-chart": dynamic(
    () => import("../../../blocks/data/road-safety-state-chart.tsx"),
    "blocks/data/road-safety-state-chart.tsx",
  ),
  "acf/data-road-safety-visualisation": dynamic(
    () => import("../../../blocks/data/road-safety-visualisation.tsx"),
    "blocks/data/road-safety-visualisation.tsx",
  ),
  "acf/data-transport-affordability-categories": dynamic(
    () => import("../../../blocks/data/transport-affordability-categories.tsx"),
    "blocks/data/transport-affordability-categories.tsx",
  ),
  "acf/data-transport-affordability-header": dynamic(
    () => import("../../../blocks/data/transport-affordability-header.tsx"),
    "blocks/data/transport-affordability-header.tsx",
  ),
  "acf/data-transport-affordability-location": dynamic(
    () => import("../../../blocks/data/transport-affordability-location.tsx"),
    "blocks/data/transport-affordability-location.tsx",
  ),
  "acf/data-transport-affordability-over-time": dynamic(
    () => import("../../../blocks/data/transport-affordability-over-time.tsx"),
    "blocks/data/transport-affordability-over-time.tsx",
  ),
  "acf/forms-gravity-form": FormsGravityForm,
  "acf/general-accordion-group": GeneralAccordionGroup,
  "acf/general-anchor": GeneralAnchor,
  "acf/general-buy-an-idp": GeneralBuyAnIdp,
  "acf/general-card-dashboard": GeneralCardDashboard,
  "acf/general-card-focus-area": GeneralCardFocusArea,
  "acf/general-card-multi": GeneralCardMulti,
  "acf/general-card-pillars": GeneralCardPillars,
  "acf/general-card-single": GeneralCardSingle,
  "acf/general-chart": GeneralChart,
  "acf/general-child-pages": GeneralChildPages,
  "acf/general-club-list": GeneralClubList,
  "acf/general-contact-panel": GeneralContactPanel,
  "acf/general-data-insight": GeneralDataInsight,
  "acf/general-file-download-group": GeneralFileDownloadGroup,
  "acf/general-footer-cta": GeneralFooterCta,
  "acf/general-get-involved": GeneralGetInvolved,
  "acf/general-header-with-links": GeneralHeaderWithLinks,
  "acf/general-idp-check": GeneralIdpCheck,
  "acf/general-inline-cta": GeneralInlineCta,
  "acf/general-link-group-with-images": dynamic(
    () => import("../../../blocks/general/link-group-with-images.tsx"),
    "blocks/general/link-group-with-images.tsx",
  ),
  "acf/general-multi-dropdown-widget": GeneralMultiDropdownWidget,
  "acf/general-multi-section-widget": GeneralMultiSectionWidget,
  "acf/general-next-page": GeneralNextPage,
  "acf/general-pill-list": GeneralPillList,
  "acf/general-projects": GeneralProjects,
  "acf/general-quick-links": GeneralQuickLinks,
  "acf/general-quote-swiper": GeneralQuoteSwiper,
  "acf/general-team-members": GeneralTeamMembers,
  "acf/general-timed-cards": GeneralTimedCards,
  "acf/general-title-with-button": GeneralTitleWithButton,
  "acf/home-data-dashboards": dynamic(
    () => import("../../../blocks/home/data-dashboards.tsx"),
    "blocks/home/data-dashboards.tsx",
  ),
  "acf/home-hero-document-highlight": HomeHeroDocumentHighlight,
  "acf/home-home-intro": dynamic(() => import("../../../blocks/home/home-intro.tsx"), "blocks/home/home-intro.tsx"),
  "acf/home-research-hub-entry": dynamic(
    () => import("../../../blocks/home/research-hub-entry.tsx"),
    "blocks/home/research-hub-entry.tsx",
  ),
  "acf/mailchimp-update-preferences": MailchimpUpdatePreferences,
  "acf/news-category-filter": NewsCategoryFilter,
  "acf/news-curated-documents": NewsCuratedDocuments,
  "acf/news-curated-news": NewsCuratedNews,
  "acf/news-hero-article": NewsHeroArticle,
  "acf/publications-publications-group": PublicationsPublicationsGroup,
  "acf/publications-publications-list": PublicationsPublicationsList,
  "acf/rsrh-distraction-chart": dynamic(
    () => import("../../../blocks/rsrh/distraction-chart.tsx"),
    "blocks/rsrh/distraction-chart.tsx",
  ),
  "acf/rsrh-driving-distractibility-tool": dynamic(
    () => import("../../../blocks/rsrh/driving-distractibility-tool.tsx"),
    "blocks/rsrh/driving-distractibility-tool.tsx",
  ),
  "acf/rsrh-fatigue-detection-technology-assessment": dynamic(
    () => import("../../../blocks/rsrh/fatigue-detection-technology-assessment.tsx"),
    "blocks/rsrh/fatigue-detection-technology-assessment.tsx",
  ),
  "acf/rsrh-feature-video": dynamic(
    () => import("../../../blocks/rsrh/feature-video.tsx"),
    "blocks/rsrh/feature-video.tsx",
  ),
  "acf/rsrh-rsrh-header": dynamic(() => import("../../../blocks/rsrh/rsrh-header.tsx"), "blocks/rsrh/rsrh-header.tsx"),
  "acf/rsrh-tools-container": dynamic(
    () => import("../../../blocks/rsrh/tools-container.tsx"),
    "blocks/rsrh/tools-container.tsx",
  ),
  ...core,
};

const info = {
  "acf/data-data-header": { "slug": "data/data-header", "tags": ["root"], "flags": {} },
  "acf/data-evindex-fuel-type-over-time": { "slug": "data/evindex-fuel-type-over-time", "tags": ["root"], "flags": {} },
  "acf/data-evindex-geographical-distribution": {
    "slug": "data/evindex-geographical-distribution",
    "tags": ["root"],
    "flags": {},
  },
  "acf/data-evindex-header": { "slug": "data/evindex-header", "tags": ["root"], "flags": {} },
  "acf/data-evindex-international-comparison": {
    "slug": "data/evindex-international-comparison",
    "tags": ["root"],
    "flags": {},
  },
  "acf/data-evindex-intro-page": { "slug": "data/evindex-intro-page", "tags": ["root"], "flags": {} },
  "acf/data-evindex-new-vehicle-sales": { "slug": "data/evindex-new-vehicle-sales", "tags": ["root"], "flags": {} },
  "acf/data-evindex-sales-by-fuel-type": { "slug": "data/evindex-sales-by-fuel-type", "tags": ["root"], "flags": {} },
  "acf/data-evindex-sales-by-manufacturer": {
    "slug": "data/evindex-sales-by-manufacturer",
    "tags": ["root"],
    "flags": {},
  },
  "acf/data-evindex-sales-by-vehicle-and-fuel": {
    "slug": "data/evindex-sales-by-vehicle-and-fuel",
    "tags": ["root"],
    "flags": {},
  },
  "acf/data-evindex-sales-jurisdiction": { "slug": "data/evindex-sales-jurisdiction", "tags": ["root"], "flags": {} },
  "acf/data-evindex-vehicle-specification-information": {
    "slug": "data/evindex-vehicle-specification-information",
    "tags": ["root"],
    "flags": {},
  },
  "acf/data-road-safety-block": { "slug": "data/road-safety-block", "tags": ["root"], "flags": {} },
  "acf/data-road-safety-chart-container": { "slug": "data/road-safety-chart-container", "tags": ["root"], "flags": {} },
  "acf/data-road-safety-section-header": {
    "slug": "data/road-safety-section-header",
    "tags": ["root", "evindex"],
    "flags": {},
  },
  "acf/data-road-safety-state-chart": { "slug": "data/road-safety-state-chart", "tags": ["root"], "flags": {} },
  "acf/data-road-safety-visualisation": { "slug": "data/road-safety-visualisation", "tags": ["root"], "flags": {} },
  "acf/data-transport-affordability-categories": {
    "slug": "data/transport-affordability-categories",
    "tags": ["root"],
    "flags": {},
  },
  "acf/data-transport-affordability-header": {
    "slug": "data/transport-affordability-header",
    "tags": ["root"],
    "flags": {},
  },
  "acf/data-transport-affordability-location": {
    "slug": "data/transport-affordability-location",
    "tags": ["root"],
    "flags": {},
  },
  "acf/data-transport-affordability-over-time": {
    "slug": "data/transport-affordability-over-time",
    "tags": ["root"],
    "flags": {},
  },
  "acf/forms-gravity-form": { "slug": "forms/gravity-form", "tags": ["root"], "flags": {} },
  "acf/general-accordion-group": { "slug": "general/accordion-group", "tags": ["root"], "flags": {} },
  "acf/general-anchor": { "slug": "general/anchor", "tags": ["root"], "flags": {} },
  "acf/general-buy-an-idp": { "slug": "general/buy-an-idp", "tags": ["root"], "flags": {} },
  "acf/general-card-dashboard": { "slug": "general/card-dashboard", "tags": ["root"], "flags": {} },
  "acf/general-card-focus-area": { "slug": "general/card-focus-area", "tags": ["root"], "flags": {} },
  "acf/general-card-multi": { "slug": "general/card-multi", "tags": ["root"], "flags": {} },
  "acf/general-card-pillars": { "slug": "general/card-pillars", "tags": ["root"], "flags": {} },
  "acf/general-card-single": { "slug": "general/card-single", "tags": ["root"], "flags": {} },
  "acf/general-chart": { "slug": "general/chart", "tags": ["root"], "flags": {} },
  "acf/general-child-pages": { "slug": "general/child-pages", "tags": ["root"], "flags": {} },
  "acf/general-club-list": { "slug": "general/club-list", "tags": ["root"], "flags": {} },
  "acf/general-contact-panel": { "slug": "general/contact-panel", "tags": ["root"], "flags": {} },
  "acf/general-data-insight": { "slug": "general/data-insight", "tags": ["root"], "flags": {} },
  "acf/general-file-download-group": { "slug": "general/file-download-group", "tags": ["root"], "flags": {} },
  "acf/general-footer-cta": { "slug": "general/footer-cta", "tags": ["root"], "flags": {} },
  "acf/general-get-involved": { "slug": "general/get-involved", "tags": ["root"], "flags": {} },
  "acf/general-header-with-links": { "slug": "general/header-with-links", "tags": ["root"], "flags": {} },
  "acf/general-idp-check": { "slug": "general/idp-check", "tags": ["root"], "flags": {} },
  "acf/general-inline-cta": { "slug": "general/inline-cta", "tags": ["root"], "flags": {} },
  "acf/general-link-group-with-images": { "slug": "general/link-group-with-images", "tags": ["root"], "flags": {} },
  "acf/general-multi-dropdown-widget": { "slug": "general/multi-dropdown-widget", "tags": ["root"], "flags": {} },
  "acf/general-multi-section-widget": { "slug": "general/multi-section-widget", "tags": ["root"], "flags": {} },
  "acf/general-next-page": { "slug": "general/next-page", "tags": ["root"], "flags": {} },
  "acf/general-pill-list": { "slug": "general/pill-list", "tags": ["root"], "flags": {} },
  "acf/general-projects": { "slug": "general/projects", "tags": ["root"], "flags": {} },
  "acf/general-quick-links": { "slug": "general/quick-links", "tags": ["root"], "flags": {} },
  "acf/general-quote-swiper": { "slug": "general/quote-swiper", "tags": ["root"], "flags": {} },
  "acf/general-team-members": { "slug": "general/team-members", "tags": ["root"], "flags": {} },
  "acf/general-timed-cards": { "slug": "general/timed-cards", "tags": ["root"], "flags": {} },
  "acf/general-title-with-button": { "slug": "general/title-with-button", "tags": ["root"], "flags": {} },
  "acf/home-data-dashboards": { "slug": "home/data-dashboards", "tags": ["root"], "flags": {} },
  "acf/home-hero-document-highlight": { "slug": "home/hero-document-highlight", "tags": ["root"], "flags": {} },
  "acf/home-home-intro": { "slug": "home/home-intro", "tags": ["root"], "flags": {} },
  "acf/home-research-hub-entry": { "slug": "home/research-hub-entry", "tags": ["root"], "flags": {} },
  "acf/mailchimp-update-preferences": { "slug": "mailchimp/update-preferences", "tags": ["root"], "flags": {} },
  "acf/news-category-filter": { "slug": "news/category-filter", "tags": ["root"], "flags": {} },
  "acf/news-curated-documents": { "slug": "news/curated-documents", "tags": ["root"], "flags": {} },
  "acf/news-curated-news": { "slug": "news/curated-news", "tags": ["root"], "flags": {} },
  "acf/news-hero-article": { "slug": "news/hero-article", "tags": ["root"], "flags": {} },
  "acf/publications-publications-group": { "slug": "publications/publications-group", "tags": ["root"], "flags": {} },
  "acf/publications-publications-list": { "slug": "publications/publications-list", "tags": ["root"], "flags": {} },
  "acf/rsrh-distraction-chart": { "slug": "rsrh/distraction-chart", "tags": ["root"], "flags": {} },
  "acf/rsrh-driving-distractibility-tool": {
    "slug": "rsrh/driving-distractibility-tool",
    "tags": ["root"],
    "flags": {},
  },
  "acf/rsrh-fatigue-detection-technology-assessment": {
    "slug": "rsrh/fatigue-detection-technology-assessment",
    "tags": ["root"],
    "flags": {},
  },
  "acf/rsrh-feature-video": { "slug": "rsrh/feature-video", "tags": ["root"], "flags": {} },
  "acf/rsrh-rsrh-header": { "slug": "rsrh/rsrh-header", "tags": ["root"], "flags": {} },
  "acf/rsrh-tools-container": { "slug": "rsrh/tools-container", "tags": ["root"], "flags": {} },
};

blockManifestReader.set(manifest, info);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
